import _throttle from 'lodash/throttle'
import _clamp from 'lodash/clamp'

const isMobile = () =>
    navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|webOS)/)

export default {
    async mounted() {
        await this.$nextTick()
        if (!isMobile()) {
            this.$el.addEventListener('mousemove', this.updateMouseX)
        }
    },
    beforeDestroy() {
        if (!isMobile()) {
            this.$el.removeEventListener('mousemove', this.updateMouseX)
        }
    },
    data() {
        return {
            mouseX: 0
        }
    },
    methods: {
        updateMouseX: _throttle(function(e) {
            const { left, width } = this.$el.getBoundingClientRect()
            this.mouseX = _clamp((e.clientX - left) / width, 0, 100)
        }, 50)
    }
}
